import React from "react";
import {
	Card,
	Button,
	makeStyles,
	Avatar,
	Tooltip,
	Badge,
	IconButton
} from "@material-ui/core";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import { useSelector, useDispatch } from "react-redux";
import { goToBoardById } from "actions";
import useWindowDimensions from "../../../../../../../hooks/useWindowDimensions";
import { ArrowForward } from "@material-ui/icons";
import IntlMessages from "util/IntlMessages";
import { upperCase, isNull } from "lodash";
import moment from "moment-timezone";

const useStyles = makeStyles({
	editBlockTitle: {
		marginBottom: 3,
		fontSize: 22,
		fontWeight: 500,
		color: "#575757",
		display: 'flex',
		alignItems: 'baseline',
		gap: 10,
		flexWrap: 'wrap'
	},
	editBlockUbTitle: {
		fontSize: "16px",
		color: "#575757"
	}
});

export default function From(props) {
	const dispatch = useDispatch();
	const classes = useStyles();
	const { width } = useWindowDimensions();

	const authUser = useSelector(state => state.auth.authUser);

	const goToBoard = () => {
		dispatch(
			goToBoardById(authUser.user_Afid, authUser.user_id, props.board.id)
		);
	};

	const returnAdress = CE => {
		const adressLine = `${CE.ProjectAdress ?? ""}, ${CE.ProjectPostnr ??
			""} ${CE.ProjectOrt ?? ""}`.trim();
		return adressLine.length < 3 ? "" : `, ${adressLine}`;
	};

	return (
		<Card style={{ borderRadius: 12 }} className="px-4 py-3">
			<div className="d-flex align-items-center" style={{ minHeight: 56 }}>
				<div className="mr-3">
					<AssessmentOutlinedIcon
						style={{
							color: "rgb(40, 200, 185)",
							fontSize: 40,
							transform: "rotate(180deg) scaleX(-1)"
						}}
					/>
				</div>
				<div style={{ flexGrow: 1 }}>
					<h3 className={classes.editBlockTitle}>
						{props.board.BoardName}
						{moment(props.board.start).toDate() !==
							moment(props.board.end).toDate() && (
								<span style={{ fontSize: "16px", color: "#575757", display: 'flex', alignItems: 'center', fontWeight: 500, gap: 5 }}>
									{moment(props.board.start).format("DD-MM-YYYY")}
									<ArrowForward color="primary" style={{fontSize: 16}}/>
									{moment(props.board.end).format("DD-MM-YYYY")}
								</span>
							)}
					</h3>
					<p className={classes.editBlockUbTitle}>{`${props.board.KundNamn
						} ${returnAdress(props.board)}`}</p>
				</div>
				<div className="d-flex align-items-center" style={{ gap: 10 }}>
					{props.board.AFirstName && (
						<Tooltip
							title={`${props.board.AFirstName} ${props.board.ALastName}`}
							aria-label={`${props.board.AFirstName} ${props.board.ALastName}`}
						>
							<Avatar
								style={{ fontSize: "12px" }}
								className="bg-blue darken-3 text-white size-40"
								src={props.board.AProfilePicUrl}
							>
								{upperCase(props.board.AFirstName[0])}
								{isNull(props.board.ALastName)
									? ""
									: upperCase(props.board.ALastName[0])}
							</Avatar>
						</Tooltip>
					)}
					{width < 600 ? (
						<IconButton onClick={() => goToBoard()} color="primary">
							<ArrowForward style={{ fontSize: 35 }} />
						</IconButton>
					) : (
						<Button
							onClick={() => goToBoard()}
							variant="outlined"
							size="large"
							color="primary"
						>
							<IntlMessages id="Project.to.board" />
						</Button>
					)}
				</div>
			</div>
		</Card>
	);
}
